/**
 * Fin de session : purge du jeton et retour au login.
 *
 * Point unique pour que les trois chemins d'appel du back-office — axios par
 * défaut, les deux instances locationApi, et les fetch() bruts — réagissent
 * identiquement à un 401.
 */

import { fermerSession } from "./role";

/* Plusieurs appels parallèles peuvent recevoir 401 en même temps ; on ne
   déclenche la redirection qu'une fois. */
let redirectionEnCours = false;

/* Pages déjà hors session : y rediriger provoquerait une boucle, et un 401 y
   est une réponse métier normale (mauvais identifiants). */
const PAGES_PUBLIQUES = ["/sign_in", "/forgotpassword"];

export function onUnauthorized(): void {
  if (redirectionEnCours) return;
  if (PAGES_PUBLIQUES.includes(window.location.pathname)) return;

  redirectionEnCours = true;
  fermerSession();
  window.location.href = "/sign_in";
}
